export const SHOPIFY_DATA = {
    childid: [],
};

export function save_specialgift_childid(childid_str) {
    for (let childid of childid_str.split('|')) {
        SHOPIFY_DATA.childid.push(childid);
    }
}
